class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
  let allSearchForms = [];
  this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
  this.input.addEventListener('focus', this.onInputFocus.bind(this));
  if (allSearchForms.length < 2) return;

  allSearchForms.forEach((form) => {
    form.addEventListener('reset', this.onFormReset.bind(this));

    // ⬇️ Add this to ensure type=product on submit
    form.addEventListener('submit', (e) => {
      console.log('Form submitted');
      const typeInput = form.querySelector('input[name="type"]');
      if (!typeInput) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'type';
        input.value = 'product';
        form.appendChild(input);
      } else {
        typeInput.value = 'product';
      }
    });
  });

  this.allSearchInputs.forEach((input) =>
    input.addEventListener('input', this.onInput.bind(this))
  );
}


  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
    console.log('Input event triggered');
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);
